import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import { trackActivationHomePageView } from "app/pages/activation/helpers/trackActivationHomePageView";
import Project from "app/pages/activation/modules/Project/Project";
import {
    ACTIVATION_PROJECT_ROUTE,
    ACTIVATION_HOME_URL,
    ACTIVATION_ROOT_ROUTE,
    DEFAULT_ACTIVATION_GRANULARITY,
} from "app/pages/activation/routing/constants";
import { onRedirectToActivation } from "app/pages/activation/routing/redirectHooks/onRedirectToActivation";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";

import { CONFIG_ID, SECONDARY_BAR_TYPE } from "./constants";

export const projectPageConfig = {
    [ACTIVATION_PROJECT_ROUTE]: {
        parent: ACTIVATION_ROOT_ROUTE,
        url: `${ACTIVATION_HOME_URL}/:key/:country/:webSource?timeGranularity&{shouldScrollToTopics:bool}&{isAddTopicModalOpened:bool}&{shouldScrollToRT: bool}`,
        component: Project,
        configId: CONFIG_ID,
        configIdDeps: ["WebAnalysis", "MobileWeb", "MobileWebWorldwide"],
        pageId: {
            section: "homepage",
            subSection: "activation project",
        },
        trackingId: {
            section: "activation homepage",
            subSection: "project",
            subSubSection: "activation homepage",
        },
        defaultQueryParams: {
            timeGranularity: DEFAULT_ACTIVATION_GRANULARITY,
        },
        redirectTo: redirectPipe(onRedirectToActivation() as any),
        pageTitle: "activation.page.title",
        isSecondaryBarOpen: false,
        secondaryBarType: SECONDARY_BAR_TYPE,
        secondaryBarType3: SecondarySideBarType3.Activation,
        hideSecondaryBar3: true,
        hideFromRecents: true,
        data: {
            pageViewTracking: ({ toParams, toState }: FixmeType) => {
                trackActivationHomePageView({ toParams, toState });
            },
        },
        isPrimarySidebarAlwaysOpen: true,
    },
};
